module.exports = __webpack_public_path__ + "img/thumb_14.d528c968.jpg";